<template>
  <div class="end">
    <div class="end__zw"></div>
    <img class="end__title" src="../../assets/images/end_title1.png" alt="" />
    <img class="end__title2" src="../../assets/images/end_title2.png" alt="" />
    <img
      class="end__btn"
      @click="showLoginPop = true"
      src="../../assets/images/end_btn.png"
      alt=""
    />
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
const showLoginPop = ref(false);
const router = useRouter();
router.push({ name: "LoginPc" });
</script>
<style lang="scss" scoped>
.end {
  width: 24.75rem;
  height: 55.078rem;
  background-image: url("../../assets/images/login_bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  &__zw {
    width: 100%;
    height: 11.088rem;
  }
  &__title {
    width: 19.8rem;
    height: auto;
  }

  &__title2 {
    width: 21.879rem;
    height: auto;
    margin: 0;
    padding: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2.508rem;
  }
  &__btn {
    width: 12.54rem;
    height: auto;
    margin: 0;
    padding: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5.973rem;
    cursor: pointer;
  }
}
</style>
